import React from 'react';
import { Theme, Typography } from '@mui/material';

const titleSx = (theme: Theme) => ({
  color: theme.palette.text.primary,
  flexGrow: 1,
  fontWeight: 'bold',
});

export interface PageTitleProps {
  pageTitle: string;
}

const PageTitle: React.FC<React.PropsWithChildren<PageTitleProps>> = (props) => {
  const { pageTitle } = props;

  return (
    <Typography variant="h6" sx={titleSx}>
      {pageTitle}
    </Typography>
  );
};
export default PageTitle;
